module.exports = __webpack_public_path__ + "img/ic_favorite_device_like.e3dc9a22.svg";